/** Ritmo visual compartido con Login (TON × estudio). */
export const STUDIO_ACCENT = "#7f9dac";
export const STUDIO_ACCENT_DEEP = "#5f7d8c";
export const STUDIO_INK = "#1c1c1c";
export const STUDIO_HAIRLINE = "#d4d2ce";
export const STUDIO_SURFACE = "#ffffff";
/** Papel compartido: login, sidebar, mi-dashboard. */
export const STUDIO_PAPER = "#efedea";
export const STUDIO_FONT = 'Manrope, "Helvetica Neue", Arial, sans-serif';

/**
 * Un color por bloque de navegación (sobrio, legible, sin repetir vecinos).
 * Light / dark.
 */
export const BLOCK_ICON = {
  dashboard: { light: "#3f4a52", dark: "#c5ccd2" },
  crm: { light: "#5f7d8c", dark: "#9eb6c2" },
  ai: { light: "#3a7ca5", dark: "#8ebfd9" },
  development: { light: "#a86b45", dark: "#e0b090" },
  resources: { light: "#8f7340", dark: "#d4bc7a" },
  tracking: { light: "#5f7348", dark: "#b5c49a" },
  manufacturing: { light: "#6f6294", dark: "#c4b3e0" },
  admin: { light: "#687078", dark: "#b0b8be" },
  cash: { light: "#3f7354", dark: "#95c9a8" },
  nml: { light: "#2d8a80", dark: "#7dccc0" },
  knowledge: { light: "#9a5a66", dark: "#e0a8b0" },
  tools: { light: "#5d6f94", dark: "#a8b4d4" },
  users: { light: "#566a7e", dark: "#a8b8c8" },
};

export function blockIcon(block, mode) {
  const pair = BLOCK_ICON[block];
  if (!pair) return STUDIO_ACCENT_DEEP;
  return mode === "dark" ? pair.dark : pair.light;
}

export function studioPaperBg(mode) {
  return mode === "dark" ? "#16181a" : STUDIO_PAPER;
}

export function studioSurface(mode) {
  return mode === "dark" ? "#24282b" : STUDIO_SURFACE;
}

export function studioHairline(mode) {
  return mode === "dark" ? "rgba(255,255,255,0.14)" : STUDIO_HAIRLINE;
}

export function studioInk(mode) {
  return mode === "dark" ? "rgba(255,255,255,0.94)" : STUDIO_INK;
}

export function studioMuted(mode) {
  return mode === "dark" ? "rgba(255,255,255,0.72)" : "rgba(28,28,28,0.72)";
}
